import { useSelector } from 'react-redux'
import { getLoadingState } from 'shared/store/contractors/selectors'
import { DialogWithTitleAndButtons } from 'shared/components'
import { useCountriesSelectOptions } from 'shared/hooks'
import { LoadingStatus } from 'shared/types'
import DialogForm from './ContractorForm'
import { ContractorDialogProps } from './ContractorDialog.types'

const ID_PREFIX = 'add-contractor'

const ContractorDialog = (props: ContractorDialogProps) => {
  const { phonePrefixesOptions, countriesOptions } = useCountriesSelectOptions()
  const { isOpen, onClose, dialogTitle } = props
  const isLoading = useSelector(getLoadingState)

  return (
    <DialogWithTitleAndButtons
      open={isOpen}
      onClose={onClose}
      variant="normal"
      title={dialogTitle}
    >
      <DialogForm
        phonePrefixesOptions={phonePrefixesOptions}
        countriesOptions={countriesOptions}
        isLoading={isLoading.addContractorDialog === LoadingStatus.Pending}
        idPrefix={ID_PREFIX}
        {...props}
      />
    </DialogWithTitleAndButtons>
  )
}

export default ContractorDialog
